// ProjectTileFrame.js
// Base tile wrapper that provides type-aware visual framing for workspace
// project nodes. Renders all frame variants and gates visibility with
// `if:` so only the matching frame shows.
//
// Consumed as: TypeFrame: { extends: 'ProjectTileFrame' }
// in ProjectNode.Thumbnail (workspace.js).
//
// DOMQL v3.14 note: `extends` must be a static string; dynamic frame
// selection is handled via per-frame `if:` conditions keyed on
// s.projectType. This is fully reactive — state changes re-evaluate
// the `if:` prop functions and show the correct frame.

export const ProjectTileFrame = {
  position: 'absolute',
  inset: '0',
  overflow: 'hidden',
  round: 'inherit',
  pointerEvents: 'none',

  // App / website frame (default for unknown types too)
  AppFrameLayer: {
    extends: 'AppFrame',
    if: (el, s) => !s.projectType || s.projectType === 'app' || s.projectType === 'website',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  DeckFrameLayer: {
    extends: 'DeckFrame',
    if: (el, s) => s.projectType === 'deck',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  MobileFrameLayer: {
    extends: 'MobileFrame',
    if: (el, s) => s.projectType === 'mobile',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  DesktopFrameLayer: {
    extends: 'DesktopFrame',
    if: (el, s) => s.projectType === 'desktop',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  TVFrameLayer: {
    extends: 'TVFrame',
    if: (el, s) => s.projectType === 'tv',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  LibraryFrameLayer: {
    extends: 'LibraryFrame',
    if: (el, s) => s.projectType === 'library',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  },

  PlatformFrameLayer: {
    extends: 'PlatformFrame',
    if: (el, s) => s.projectType === 'platform',
    position: 'absolute',
    inset: '0',
    round: 'inherit',
    pointerEvents: 'none'
  }
}
